import { render, staticRenderFns } from "./TabHelp.vue?vue&type=template&id=6634881e&scoped=true&"
import script from "./TabHelp.vue?vue&type=script&lang=js&"
export * from "./TabHelp.vue?vue&type=script&lang=js&"
import style0 from "./TabHelp.vue?vue&type=style&index=0&id=6634881e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6634881e",
  null
  
)

export default component.exports